import React from 'react';
import { Box } from '@mui/material';
import { AssistantChatPanel } from '../../components/chat/AssistantChatPanel';

export const Home = () => (
  <Box
    sx={{
      width: '100%',
      minHeight: 'calc(100vh - 140px)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      py: { xs: 2, sm: 3 },
    }}
  >
    <Box sx={{ width: '100%', maxWidth: 720 }}>
      <AssistantChatPanel />
    </Box>
  </Box>
);
